import { useRef, useState } from "react"
import { Box, Button, Stack, Typography } from "@mui/material"
import { wasmModule, stageControl } from "@/gluelayer"
import { useAppDispatch, useAppSelector } from "@/core/app/hooks"
import { setOpenProgressDlg, setProgressDlgMsg } from "@/UDTreat/udSetupSlice"
import { RightPage } from "@/UDTreat/right/RightPage"
import { UDTitleButtons } from "@/UDTreat/custom/UDSelectOptions"
import { SpaceBar } from "@mui/icons-material"
import { RootState } from "../../../core/app/store"
import {
  setStageShowMode,
  setNoPermitGoPassiveAlignerWarning,
} from "@/UDTreat/udTreatSlice"
import { useEffect } from "react"
import { QuickConfirmDlg } from "../QuickDlg"

const autoStagingOptions = {
  title: "Auto Staging",
  group: "AutoStaging",
  options: ["Add All", "Remove All"],
}

export const QuickStaging = (props) => {
  const dispatch = useAppDispatch()
  const { stageShowMode } = useAppSelector(
    (state: RootState) => state.udTreatService,
  )
  const [showConfirmDlg, setShowConfirmDlg] = useState(false)
  const curSel = useRef(0)

  const onAutoStaging = () => {
    dispatch(setOpenProgressDlg(true))
    dispatch(setProgressDlgMsg("Auto Staging: upper jaw..."))
    setTimeout(() => {
      // wait 0.1s to let UI refresh then run next step
      wasmModule.stagingcontoler.AutoAllStage(0, 3)
      dispatch(
        setProgressDlgMsg("Auto Staging: upper jaw... done! Now lower jaw..."),
      )
      setTimeout(() => {
        wasmModule.stagingcontoler.AutoAllStage(1, 3)
        dispatch(
          setProgressDlgMsg(
            "Auto Staging: upper jaw... done! Now lower jaw... done! ",
          ),
        )
        dispatch(setOpenProgressDlg(false))
      }, 100)
    }, 100)
  }

  const onPassiveAligner = () => {
    if (stageShowMode === "") {
      //into passive aligner
      if (stageControl.getMaxStageNodeIndex() > 0) {
        dispatch(setStageShowMode("passive_aligner"))
      } else {
        dispatch(setNoPermitGoPassiveAlignerWarning(true))
        return false
      }
    } else {
      //out passive aligner
      dispatch(setStageShowMode(""))
    }
    return true
  }

  const onChangeSel1 = (group: string, sel: number) => {
    console.log(group, ":", sel, "is selected!")
    if (group === "AutoStaging") {
      switch (sel) {
        case 0:
          onAutoStaging()
          break
        case 1:
          wasmModule.stagingcontoler.RemoveAutoAllStage(0)
          wasmModule.stagingcontoler.RemoveAutoAllStage(1)
          break
      }
    }
  }

  useEffect(() => {
    return () => {
      console.log("dealloc QuickStaging")
      dispatch(setStageShowMode(""))
    }
  }, [])

  return (
    <RightPage
      title="Staging"
      sx={{ width: 205 }}
      onClose={props.onClose}
      content={
        <Stack direction={"column"} spacing={2}>
          <UDTitleButtons
            wrap={true}
            key={399}
            title={autoStagingOptions.title}
            options={autoStagingOptions.options}
            onClick={(sel) => {
              curSel.current = sel
              setShowConfirmDlg(true)
            }}
          />
          <SpaceBar sx={{ width: "0px", height: "10px" }} />
          <Button
            size="small"
            variant="outlined"
            sx={{
              textTransform: "none",
              width: "55px",
              height: "46px",
              fontSize: "13px",
              whiteSpace: "pre-wrap",
              fontWeight: 600,
              color: stageShowMode === "" ? "rgba(0, 0, 0, 0.6)" : "white",
              backgroundColor:
                stageShowMode === "" ? "rgba(240, 240, 240, 1)" : "#02AFEC",
              boxShadow: "0 1px 3px 1px rgba(0, 0, 0, 0.15)",
              border: "none",
              "&:hover": {
                border: "none",
                backgroundColor:
                  stageShowMode === "" ? "rgba(240, 240, 240, 1)" : "#02AFEC",
                color: stageShowMode === "" ? "rgba(0, 0, 0, 0.6)" : "white",
              },
            }}
            onClick={() => {
              onPassiveAligner()
            }}
          >
            Passive Aligner
          </Button>
          <QuickConfirmDlg
            isOpen={showConfirmDlg}
            title="Warning: Auto Staging"
            message={
              curSel.current == 0
                ? "To create new staging, current staging will be removed and can't be undo. Continue?"
                : "Current staging will be deleted and can't be undo. Continue?"
            }
            onOk={() => {
              setShowConfirmDlg(false)
              setTimeout(() => {
                onChangeSel1(autoStagingOptions.group, curSel.current)
              }, 100)
            }}
            onCancel={() => {
              setShowConfirmDlg(false)
            }}
          />
        </Stack>
      }
      actions={<Box></Box>}
    />
  )
}
